"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.normalize = void 0;

var _palette = require("./palette");

var _widths = require("./widths");

var normalize = {
  '@global': {
    body: {
      margin: 0,
      padding: 0,
      background: _palette.palette.white,
      color: _palette.palette.bobBlack,
      fontFamily: _widths.font.montse,
      fontSize: 14,
      lineHeight: '22px',
      fontWeight: _widths.font.regular,
      '-webkit-font-smoothing': 'antialiased',
      '-moz-osx-font-smoothing': 'grayscale',
      '-webkit-text-size-adjust': '100%',
      '-moz-text-size-adjust': '100%',
      '-ms-text-size-adjust': '100%',
      'text-size-adjust': '100%'
    },
    notSelectable: {
      cursor: 'default',
      '-webkit-user-select': 'none',
      '-moz-user-select': 'none',
      '-ms-user-select': 'none',
      'user-select': 'none'
    },
    a: {
      textDecoration: 'none',
      color: _palette.palette.link,
      '&:hover': {
        outline: 'none'
      },
      '&:focus': {
        color: _palette.palette.bobBlack,
        outline: 0
      }
    }
  },
  ':focus': {
    outline: '0 !important'
  },
  'button:focus': {
    outline: 0
  },
  loadingBar: {
    position: 'fixed',
    top: 0,
    zIndex: 100,
    height: 3,
    backgroundColor: _palette.palette.white,
    boxShadow: 'rgba(0, 0, 0, .12) 0 1px 6px, rgba(0, 0, 0, .12) 0 1px 4px'
  }
};
exports.normalize = normalize;